import React from "react";
import PropTypes from "prop-types";

function Currency(symbol) {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: symbol,
    });
  } catch (error) {
    console.error(error);
    return {
      format: (value) => {
        return `${symbol} ${new Intl.NumberFormat("en-US").format(value)}`;
      },
    };
  }
}

export function Money({ currency, children, as }) {
  if (typeof currency !== "string") return children;
  if (!children || Number.isNaN(Number(children))) return children;

  const convertToMonetaryUnit = (v) => {
    if (as === "cent") return v * 100;
    if (as === "hundred") return v / 100;
    return v;
  };

  return (
    <React.Fragment>
      {Currency(currency).format(convertToMonetaryUnit(parseInt(children)))}
    </React.Fragment>
  );
}

Money.propTypes = {
  currency: PropTypes.node,
  children: PropTypes.node,
  as: PropTypes.oneOf(["cent", "hundred"]),
};
Money.defaultProps = { currency: "USD", children: null, as: "hundred" };

export default Money;
